import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useNotification } from '../context/NotificationContext';

/**
 * The ErrorPopup component displays a dismissible notification message at the bottom-right of the screen.
 * It consumes the NotificationContext to know when to display and what message to show.
 */
const NotificationPopup = () => {
  const { notification, handleClose } = useNotification();

  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert onClose={handleClose} severity={notification.type || 'info'} elevation={6} variant="filled">
        {notification.message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationPopup;